// deprecated: используй REGEXP_MATCH_TAG и REGEXP_MATCH_TAG_GLOBAL
const REGEXP_MATCH_FULL_TAG = /(\${[^}\\]*(?:\\.[^}\\]*)*})/g
const REGEXP_MATCH_TAG_SECTIONS = /(?:\${|\|)?(\/.*?\/\w*|.+?)(?:\||}|$)/gi
const REGEXP_MATCH_SECTION_CONTENT = /^(?:\${|\|)?\/?(.*?)\/?(?:\||})?$/
exports.REGEXP_MATCH_FULL_TAG = REGEXP_MATCH_FULL_TAG
exports.REGEXP_MATCH_TAG_SECTIONS = REGEXP_MATCH_TAG_SECTIONS
exports.REGEXP_MATCH_SECTION_CONTENT = REGEXP_MATCH_SECTION_CONTENT

const REGEXP_MATCH_TAG = /\${([^\| }]+)(?:\|([^\|]*?)(?:\|\/(.*?)\/)?)?}/
const REGEXP_MATCH_TAG_GLOBAL = new RegExp(REGEXP_MATCH_TAG, 'g')
exports.REGEXP_MATCH_TAG = REGEXP_MATCH_TAG
exports.REGEXP_MATCH_TAG_GLOBAL = REGEXP_MATCH_TAG_GLOBAL

const REGEXP_IS_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
exports.REGEXP_IS_UUID = REGEXP_IS_UUID

const REGEXP_IS_HEX_COLOR = /^#?([0-9a-fA-F]{6})$/
exports.REGEXP_IS_HEX_COLOR = REGEXP_IS_HEX_COLOR

const REGEXP_IS_RUSSIAN_NUMBER = /^(\+?7|8)9(\d{9})$/
const REGEXP_NON_PHONE_SYMBOLS = /[^\d+()]/g
exports.REGEXP_IS_RUSSIAN_NUMBER = REGEXP_IS_RUSSIAN_NUMBER
exports.REGEXP_NON_PHONE_SYMBOLS = REGEXP_NON_PHONE_SYMBOLS

const REGEXP_IS_EMAIL_SIMPLE = /.*?@.*?\..{2,}/
const REGEXP_IS_HTTP_SIMPLE = /^https?:\/\/.+\..+/i
const REGEXP_IS_HTTP_NOT_LOCALHOST = /^https?:\/\/(?!localhost|127\.0\.0\.1).+\..+/i
const REGEXP_IS_IP_ADDRESS = /^((25[0-5]|(2[0-4]|1[0-9]|[1-9]|)[0-9])(\.(?!$)|$)){4}$/
exports.REGEXP_IS_EMAIL_SIMPLE = REGEXP_IS_EMAIL_SIMPLE
exports.REGEXP_IS_HTTP_SIMPLE = REGEXP_IS_HTTP_SIMPLE
exports.REGEXP_IS_HTTP_NOT_LOCALHOST = REGEXP_IS_HTTP_NOT_LOCALHOST
exports.REGEXP_IS_IP_ADDRESS = REGEXP_IS_IP_ADDRESS

const REGEXP_SENDERNAME_SMS = /^[a-zA-Z0-9!?\-_.()]{4,11}$/i
const REGEXP_SENDERNAME_VOICE = /^\d{6,15}$/
exports.REGEXP_SENDERNAME_SMS = REGEXP_SENDERNAME_SMS
exports.REGEXP_SENDERNAME_VOICE = REGEXP_SENDERNAME_VOICE

const REGEXP_JWT = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/
exports.REGEXP_JWT = REGEXP_JWT

const REGEX_IPV4_WITH_MASK_OR_PATTERN = /^(?:(?:(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|\*)\.){3}(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|\*)(?:\/(?:3[0-2]|[12]?[0-9]))?)$/
exports.REGEX_IPV4_WITH_MASK_OR_PATTERN = REGEX_IPV4_WITH_MASK_OR_PATTERN
